import { ValidationError } from 'yup'

export interface IErrorForm {
  [key: string]: string
}

export const getFieldsError = (error: unknown) => {
  if (error instanceof ValidationError) {
    return error.inner.reduce(
      (acc, curr) => {
        acc[curr.path!] = curr.message
        return acc
      },
      {} as { [key: string]: string },
    )
  }

  return undefined
}
